// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2Yokf","list":"styles_list__3oXP3"};